import React from 'react';

const About = () => {
  return (
    <>
      <h1>About this App</h1>
      <p>App to search Cats using API</p>
    </>
  );
};

export default About;
